import { render, staticRenderFns } from "./data-shuoming.vue?vue&type=template&id=4b4e07fa&"
import script from "./data-shuoming.vue?vue&type=script&lang=js&"
export * from "./data-shuoming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports